export { default as LandingSchema } from './landing-schema.jsx';
